export default __webpack_public_path__ + "static/media/user-avatar.7543b234.svg";